import * as backend from '@/api/backend';
import { checkResponseStatus } from '@/util/check';
import { buildSpecialSavePayload } from '@/utils/specials';


const addPrettyTime = (special) => ({
  ...special,
  prettyRegularPrice: Number(special.regularPrice).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }),
  prettySpecialPrice: Number(special.price).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }),
});

export default {
  state: {
    specials: [],
    loading: false,
    error: false,
    specialEdit: {
      specialID: null,
      name: '',
      category: '',
      categoryColor: null,
      productCode: '',
      specialImage: '',
      specialImageURL: '',
      active: true,
      regularPrice: 0.0,
      specialPrice: 0.0,
      specialImageChanged: false,
    },
  },
  mutations: {
    fetchSpecials(state) {
      state.loading = true;
    },
    errorSpecials(state) {
      state.specials = [];
      state.loading = false;
      state.error = true;
    },
    setSpecials(state, specials) {
      state.specials = specials;
      state.loading = false;
      state.error = false;
    },
    editSpecial(state, special) {
      if (!special) {
        state.specialEdit = {
          specialID: null,
          name: '',
          category: '',
          categoryColor: null,
          productCode: '',
          specialImage: '',
          specialImageURL: '',
          active: true,
          regularPrice: 0.0,
          specialPrice: 0.0,
          specialImageChanged: false,
        };
        return;
      }
      state.specialEdit = {
        ...state.specialEdit,
        ...special,
      };
    },
  },
  actions: {
    async fetchSpecials({ commit }) {
      commit('fetchSpecials');
      try {
        const response = await backend.getSpecials();
        await checkResponseStatus(200, response);
        const json = response.data;
        commit('setSpecials', json);
      } catch (e) {
        console.error(e);
        commit('errorSpecials');
      }
    },
    async fetchSpecialsByCompanyID({ commit }, companyID) {
      commit('fetchSpecials');
      try {
        const response = await backend.getSpecials(companyID);
        await checkResponseStatus(200, response);

        const json = response.data;
        commit('setSpecials', json);
      } catch (e) {
        console.error(e);
        commit('errorSpecials');
      }
    },
    async createSpecial({ dispatch }, { special, specialImage, libraryImageId, draftToken }) {
      const response = await backend.postSpecial(special.companyID, special);

      await checkResponseStatus(201, response);

      const responseJSON = response.data;
      const { specialID } = responseJSON.response.special;

      if (libraryImageId) {
        await backend.postDealImageAssign({
          specialId: specialID,
          libraryImageId,
          accept: true,
          draftToken,
          companyId: special.companyID,
        });
      } else if (specialImage.image) {
        const image = { ...specialImage, specialID };
        await dispatch('saveSpecialImage', image);
      }

      return { specialID };
    },


    async saveSpecial({ dispatch }, {
      special, specialImage, libraryImageId, draftToken,
    }) {
      const response = await backend.putSpecial(special.specialID, special);
      await checkResponseStatus(204, response);

      if (libraryImageId) {
        await backend.postDealImageAssign({
          specialId: special.specialID,
          libraryImageId,
          accept: true,
          draftToken,
          companyId: special.companyID,
        });
      } else if (specialImage) {
        if (specialImage.changed && specialImage.image) {
          await dispatch('saveSpecialImage', specialImage);
        } else if (specialImage.changed) {
          await dispatch('deleteSpecialImage', specialImage);
        }
      }
    },
    async saveSpecialImage(context, { specialID, image }) {
      const response = await backend.postImage(`/image/special/${specialID}`, image);
      await checkResponseStatus([200, 201], response);
    },

    async deleteSpecialImage(context, { specialID }) {
      const response = await backend.deleteImage(`/image/special/${specialID}`);
      await checkResponseStatus([200, 202, 204], response);
    },

    async reviveSpecial({ dispatch, state }, { specialID }) {
      const existing = state.specials.find(
        (special) => Number(special.specialID) === Number(specialID),
      );
      if (!existing) {
        throw new Error('Deal nicht gefunden');
      }
      await dispatch('saveSpecial', {
        special: buildSpecialSavePayload(existing, { itemStatus: 0 }),
      });
    },

    async deleteSpecial(context, { specialID }) {
      const response = await backend.deleteSpecial(specialID);
      await checkResponseStatus(204, response);
    },
  },
  getters: {
    prettySpecials: (state) => state.specials.map(addPrettyTime),
  },
  namespaced: true,
};
